import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SystemModuleIndexComponent } from './crud-index/crud-index.component';
import { SystemModuleCESComponent } from './crud-ces/crud-ces.component';

const routes: Routes = [
  {
    path: '',
    component: SystemModuleIndexComponent,
  },
  {
    path: 'create',
    component: SystemModuleCESComponent,
    data: [{ action: 'create' }],
  },
  {
    path: 'view/:id',
    component: SystemModuleCESComponent,
    data: [{ action: 'view' }],
  },
  {
    path: 'edit/:id',
    component: SystemModuleCESComponent,
    data: [{ action: 'edit' }],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SystemModulesRoutingModule {}
